import { StyledLink } from '@/components/Link'
import styles from './ViewAllJobsTip.module.css'

interface ViewAllJobsTipProps {
  to?: string
  testId?: string
}

/**
 * Tip for viewing all jobs.
 */
export function ViewAllJobsTip({ to, testId }: ViewAllJobsTipProps) {
  return (
    <div className={styles.root} data-test={testId}>
      Looking for a previous job?{' '}
      <span className={styles.link}>
        <StyledLink variant="inherit" to={to}>
          View all your jobs →
        </StyledLink>
      </span>
    </div>
  )
}
